module.exports = __webpack_public_path__ + "static/media/Juli_1996.dd3eb593.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_aus_frueheren_jahren/thumb/Juli_1996.jpg
// module id = 541
// module chunks = 0